import React, { Component as C } from "react"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import PropTypes from "prop-types"
import classNames from "classnames"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import StatelessTextInput from "@cirrus/legacy/app-components/form-controls/inputs/stateless-text-input/index.jsx"

import styles from "./index.less"

class ElectFilter extends C {
  static propTypes = {
    className: PropTypes.string,
    search: PropTypes.string,
    onSearchChanged: PropTypes.func,
    dataQa: PropTypes.func,
    disableSearch: PropTypes.bool,
  }

  render() {
    let { search, className, onSearchChanged, children, dataQa, disableSearch } = this.props

    return (
      <div className={classNames(styles.listContainer, className)}>
        {!disableSearch && (
          <div>
            <div className={styles.search}>
              <StatelessTextInput
                placeholder={i18n("General:Search")}
                value={search}
                dataQa={dataQa}
                onChange={(e, value) => onSearchChanged(value)}
              />
              <Icon className={styles.searchIcon} icon="fa-search" />
            </div>
          </div>
        )}
        {children}
      </div>
    )
  }
}

export default ElectFilter
